import { graphql } from '@teachino/shared-infrastructure';

export const libraryTopicQuery = graphql(`
  query LibraryTopic($topicId: String!) {
    items(topicIdInput: { id: $topicId }) {
      __typename
      id
      name
      icon
      duration
      linkedTopics {
        id
        name
      }
      permissions {
        canEditItem
        canDuplicateItemIntoTopic
        canDeleteItemFromTopic
        canViewItemSnippetNote
        canEditItemSnippetNote
        canViewItem
      }
    }
    topic(topicIdInput: { id: $topicId }) {
      __typename
      id
      name
      goals
      usage
      permissions {
        canEditTopic
        canDuplicateTopic
        canDeleteTopicFromOwnLibrary
        canChangeTopicSharingSettings
        isTopicOwner
      }
      topicStatistics {
        linkedItemsTotal
      }
      topicCourses {
        id
        shortName
        foregroundColor
        backgroundColor
        name
      }
    }
  }
`);
